import { render } from "./savePreMoneyModel.vue?vue&type=template&id=56de3bab"
import script from "./savePreMoneyModel.vue?vue&type=script&lang=js"
export * from "./savePreMoneyModel.vue?vue&type=script&lang=js"

import "./savePreMoneyModel.vue?vue&type=style&index=0&id=56de3bab&lang=scss"

import exportComponent from "D:\\companyProject\\G10Product\\trunk\\Bestech.CloudPos\\Bestech.CloudPos.Portal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__